/**
 * TanStack Query hooks for `report-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	reportApiQueryKeys,
	type CreateReportApiBody,
	type ListReportApiResponse,
	type ReportApiRow,
} from "./api";

export function useReportApiList(): UseQueryResult<ListReportApiResponse, Error> {
	return useQuery({
		queryKey: reportApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useReportApiCreate(): UseMutationResult<ReportApiRow, Error, CreateReportApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reportApiQueryKeys.all });
		},
	});
}

export function useReportApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reportApiQueryKeys.all });
		},
	});
}
